import axios from 'axios'
import router from '../../router'
// import router from '../../router'

const state = {
  noticeData: '',
  noticeContent: '',
  dashInfoRtn: '',
  ordCodeData: '',
  custMstData: '',
  codeData: '',
  totalData: '',
  userTranRtn: '',
  agentCount: 0,
  fileData: '',
  logInfoData: ''
}

const getters = {
    getNoticeData (state) {
      return state.noticeData
    },
    getNoticeContent (state) {
      return state.noticeContent
    },
    getDashInfo (state) {
      return state.dashInfoRtn
    },
    getOrdCodeData (state) {
      return state.ordCodeData
    },
    getCustMstData (state) {
      return state.custMstData
    },
    getCodeData (state) {
      return state.codeData
    },
    getTotalData (state) {
      return state.totalData
    },
    getUserTranRtn (state) {
      return state.userTranRtn
    },
    getAgentCount (state) {
      return state.agentCount
    },
    getLogInfoData (state) {
      return state.logInfoData
    }
}

const mutations = {
    setNoticeData(state, payload) {
      state.noticeData = payload
    },
    setNoticeContent(state, payload) {
      state.noticeContent = payload
    },
    setDashInfo(state, payload) {
      state.dashInfoRtn = payload
    },
    setOrdCodeData(state, payload) {
      state.ordCodeData = payload
    },
    setCustMstData(state, payload) {
      state.custMstData = payload
    },
    setCodeData(state, payload) {
      state.codeData = payload
    },
    setTotalData(state, payload) {
      state.totalData = payload
    },
    setUserInfoTran(state, payload) {
      state.userTranRtn = payload
    },
    setAgentCount(state, payload) {
      state.agentCount = payload
    },
    setLogInfoData(state, payload) {
      state.logInfoData = payload
    }
}

const actions = {
    apiNoticeData(context, payload) {
      return new Promise((resolve, reject) => {
          axios.post('/api/noticeMain', payload)
            .then((response) => {
              // console.log(response.data)
                context.commit('setNoticeData', response.data)
                resolve()
            })
            .catch((error) => {
                if (error.response.status === 410) {
                  alert('세션이 만료되어 로그인 페이지로 이동합니다.')
                  // sessionStorage.clear()
                  // router.replace('/')
                }else{
                // console.log('error  = ' + error.message)
                // console.log(JSON.stringify(error))
                  reject(error)
                // console.log('error.response.status = ' + error.response.status)
                }
            })
      })
  },
    apiNoticeContent (context, payload) {
        return new Promise((resolve, reject) => {
          axios.post('/api/noticeDtl', payload)
            .then((response) => {
              // console.log(response.data)
              context.commit('setNoticeContent', response.data)
              resolve()
            })
            .catch((error) => {
              // catch 로 떨어졌을때 다른 페이지로 보낼지 여부 판단 필요
              if (error.response.status === 410) {
                alert('세션이 만료되어 로그인 페이지로 이동합니다.')
                sessionStorage.clear()
                router.replace('/')
              }else{
                // console.log('error  = ' + error.message)
                // console.log(JSON.stringify(error))
                reject(error)
                // console.log('error.response.status = ' + error.response.status)
              }
            })
        })
    },
    apiDashInfo (context, payload) {
      if (sessionStorage.getItem('userInfo') === null) {
        alert('세션이 만료되어 로그인 페이지로 이동합니다.')
        sessionStorage.clear()
        router.replace('/')
      }else{
        return new Promise((resolve, reject) => {
          axios.post('/api/dashInfo', payload)
            .then((response) => {
              context.commit('setDashInfo', response.data)
              resolve()
            })
            .catch((error) => {
              if (error.response.status === 410) {
                alert('세션이 만료되어 로그인 페이지로 이동합니다.')
                sessionStorage.clear()
                router.replace('/')
              }else{
                // console.log('error  = ' + error.message)
                // console.log(JSON.stringify(error))
                reject(error)
                // console.log('error.response.status = ' + error.response.status)
              }
            })
        })
    }
  },
  apiTotalData (context, payload) {
    if (sessionStorage.getItem('userInfo') === null) {
      alert('세션이 만료되어 로그인 페이지로 이동합니다.')
      sessionStorage.clear()
      router.replace('/')
    }else{
      return new Promise((resolve, reject) => {
        axios.post('/api/totalInfo', payload)
          .then((response) => {
            context.commit('setTotalData', response.data)
            resolve()
          })
          .catch((error) => {
            if (error.response.status === 410) {
              alert('세션이 만료되어 로그인 페이지로 이동합니다.')
              sessionStorage.clear()
              router.replace('/')
            }else{
              // console.log('error  = ' + error.message)
              // console.log(JSON.stringify(error))
              reject(error)
              // console.log('error.response.status = ' + error.response.status)
            }
          })
      })
    }
  },
  apiUserInfoTran(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/updateUser', payload)
        .then((response) => {
            context.commit('setUserInfoTran', response.data)
            resolve()
        })
        .catch((error) => {
            if (error.response.status === 410) {
              alert('세션이 만료되어 로그인 페이지로 이동합니다.')
              sessionStorage.clear()
              router.replace('/')
            }else{
            // console.log('error  = ' + error.message)
            // console.log(JSON.stringify(error))
              reject(error)
            // console.log('error.response.status = ' + error.response.status)
            }
        })
    })
  },
  apiLogInfoData(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/logInfo', payload)
        .then((response) => {
            context.commit('setLogInfoData', response.data)
            resolve()
        })
        .catch((error) => {
            if (error.response.status === 410) {
              alert('세션이 만료되어 로그인 페이지로 이동합니다.')
              sessionStorage.clear()
              router.replace('/')
            }else{
              reject(error)
            }
        })
    })
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}
